import {AlarmsState} from '../state/alarms.state';
import {
  Actions,
  ALARMS_ACTIVE_EVENTS_FETCHED,
  ALARMS_EVENT_ACKNOWLEDGED,
  ALARMS_EVENT_CLEARED,
  ALARMS_EVENT_FETCHED,
} from '../actions/alarms.actions';


const initialState: AlarmsState = {
  activeEvents: [],
  loaded: false,
};

export function AlarmsReducer(state: AlarmsState = initialState, action: Actions): AlarmsState {
  let newState: AlarmsState;

  switch (action.type) {
    case ALARMS_ACTIVE_EVENTS_FETCHED:
      return {
        activeEvents: action.events ?? [],
        loaded: true,
      };
    case ALARMS_EVENT_CLEARED:
      newState = JSON.parse(JSON.stringify(state));

      newState.activeEvents = newState.activeEvents.filter((e) => {
        return e.UUID !== action.event.UUID;
      });

      return newState;
    case ALARMS_EVENT_FETCHED:
    case ALARMS_EVENT_ACKNOWLEDGED:
      newState = JSON.parse(JSON.stringify(state));

      newState.activeEvents = newState.activeEvents.filter((e) => {
        return e.UUID !== action.event.UUID;
      });

      newState.activeEvents.push(action.event);

      return newState;
    default:
      return state;
  }
}
